/**
 * The Info tab's parental-controls block (fix Z2.1/Z2.2) — the header
 * ("Parental controls" + the shield + where they apply) plus the rule rows,
 * replacing the OLD `GameRulesComponent` badge+popover that used to be
 * `require()`'d straight into `rail/info/InfoPanel/View.tsx`.
 *
 * Takes the account's raw rule KEYS (`session.customRules`, the same shape
 * `InfoPanelModel.rules` already carried) — `InfoPanelView` only decides
 * WHETHER to mount this (`rules.length > 0`), never what the rows say.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import Icon from '../../../components/Icon';
import {SPACE} from '../../../theme/tokens';
import {useV2Theme} from '../../../theme/useV2Theme';
import {Txt} from '../../../ui';
import {parentalRulesFor} from './rules';
import ParentalRulesList from './View';

const ICON_SIZE = 17;

export type ParentalRulesSectionProps = {
  rules: string[];
};

function ParentalRulesSection({rules}: ParentalRulesSectionProps) {
  const tokens = useV2Theme(s => s.tokens);
  return (
    <View testID="v2-info-rules" style={styles.section}>
      <View style={styles.header}>
        <Icon name="shield" size={ICON_SIZE} color={tokens.ink2} />
        <Txt variant="rowName">Parental controls</Txt>
      </View>
      <Txt variant="caption" tone="muted">
        Set for this account · active in your games
      </Txt>
      <ParentalRulesList rules={parentalRulesFor(rules)} />
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    gap: SPACE.xs,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: SPACE.xs,
  },
});

export default React.memo(ParentalRulesSection);
